import { IMessage } from 'pages/App/components/Chat/ChatPopup/Dialog/Message'

import { ChatDialogState } from './duck'

export const getUnreadMessages = (
  chat: ChatDialogState
): Array<IMessage> | null => chat.unreadMessages
